import { Icon } from "@material-ui/core";
import styled from "styled-components";

import { themeColors } from "js/react/sharedStyles";

export const StyledFoldersSection = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    flex: 1;
    min-height: 0;
    overflow: hidden;
`;

export const SideBarItem = styled.div`
    width: 100%;
    color: #444;
    font-size: 14px;
    letter-spacing: 0px;
    font-weight: 600;
    display: flex;
    flex-shrink: 0;
    margin-bottom: 0px;
    align-items: flex-start;
    overflow: hidden;
    padding: 12px 10px;
    transition: background-color 300ms;
    background: none;
    cursor: pointer;

    & > .material-icons {
        font-size: 18px;
        margin-right: 10px;
        color: #666;
    }

    &:hover:not(.selected),
    &.hover:not(.selected) {
        background: #F8F8F8;

        & > .material-icons {
            color: #11A9E2;
        }
    }

    &.selected {
        cursor: default;
        background: ${themeColors.lightBlue};

        & > .material-icons {
            color: ${themeColors.ui_blue};
        }

        &:hover,
        &.hover {
            background: ${themeColors.lightBlue};
        }
    }

    .folder-name {
        overflow: hidden;
        text-overflow: ellipsis;
    }
`;

export const SideBarLabel = styled.div`
    width: 100%;
    flex-shrink: 0;
    font-size: 12px;
    display: flex;
    align-items: center;
    text-transform: uppercase;
    color: ${themeColors.mediumGray};
    padding: 6px 0;

    & > *:nth-child(2) {
        margin-left: auto;
        margin-right: 0;
    }
`;

export const FolderContainer = styled.div`
    width: 100%;
    flex: 1;
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
`;

export const LibraryFolder = styled(SideBarItem)`
    padding: 10px;
    align-items: center;

    .MuiIconButton-root {
        padding: 0;
        opacity: 0;
    }

    .expand-arrow {
        font-size: 24px;
        margin-right: 0;
    }

    &:hover,
    &.hover {
        .MuiIconButton-root {
            opacity: 1;
        }
    }
`;

export const StyledAddIcon = styled(Icon)`
    &&& {
        font-size: 20px;
    }
`;

export function selectedClass(selected: boolean): string {
    return selected ? "selected" : "";
}

const DEFAULT_WORKSPACE_RESOURCES_SIDEBAR_WIDTH = 200;

const WORKSPACE_RESOURCES_SIDEBAR_WIDTH_STORAGE_KEY = "bai-team-library-folder-sidebar-width";

export function getWorkspaceResourcesSidebarWidth(): number {
    const saved = parseInt(localStorage.getItem(WORKSPACE_RESOURCES_SIDEBAR_WIDTH_STORAGE_KEY) ?? "", 10);
    if (Number.isFinite(saved)) {
        return saved;
    }

    return DEFAULT_WORKSPACE_RESOURCES_SIDEBAR_WIDTH;
}

export function saveWorkspaceResourcesSidebarWidth(width: number): void {
    localStorage.setItem(WORKSPACE_RESOURCES_SIDEBAR_WIDTH_STORAGE_KEY, String(width));
}
